import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Skeleton } from "../../../../../Skeleton/index.js";
import { useImagePreload } from "../../../../../hooks/index.js";
import { useHeight } from "../hooks/index.js";
import { MediaEmpty } from "../../../../../MediaEmpty/index.js";
import { Icon } from "../../../../../Icon/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ImagesGallerySlider_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ImagesGallerySlider_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const ImagesGallerySlider = (t0)=>{
    var _images_currentIndex;
    const $ = c(48);
    const { images, editable, hasError: t1 } = t0;
    const hasError = void 0 === t1 ? false : t1;
    const { editorHeight, maxHeight } = useHeight();
    const [currentIndex, setCurrentIndex] = useState(0);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {};
        $[0] = t2;
    } else t2 = $[0];
    const [loadedImages, setLoadedImages] = useState(t2);
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {};
        $[1] = t3;
    } else t3 = $[1];
    const preloadCache = useRef(t3);
    const staticHeight = editable ? editorHeight : maxHeight;
    const currentSrc = null == (_images_currentIndex = images[currentIndex]) ? void 0 : _images_currentIndex.src;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            cache: preloadCache
        };
        $[2] = t4;
    } else t4 = $[2];
    const imageStatus = useImagePreload(currentSrc, t4);
    let t5;
    let t6;
    if ($[3] !== currentSrc || $[4] !== imageStatus) {
        t5 = ()=>{
            if (!currentSrc || "idle" === imageStatus) return;
            preloadCache.current[currentSrc] = true;
            setLoadedImages((prev)=>_object_spread_props(_object_spread({}, prev), {
                    [currentSrc]: {
                        loading: "loading" === imageStatus,
                        fulfilled: "complete" === imageStatus,
                        rejected: "failed" === imageStatus
                    }
                }));
        };
        t6 = [
            currentSrc,
            imageStatus
        ];
        $[3] = currentSrc;
        $[4] = imageStatus;
        $[5] = t5;
        $[6] = t6;
    } else {
        t5 = $[5];
        t6 = $[6];
    }
    useEffect(t5, t6);
    let t7;
    if ($[7] !== images) {
        t7 = (index)=>{
            var _images_index;
            if (null == (_images_index = images[index]) ? void 0 : _images_index.src) setCurrentIndex(index);
        };
        $[7] = images;
        $[8] = t7;
    } else t7 = $[8];
    const goToNext = t7;
    let t8;
    if ($[9] !== currentIndex || $[10] !== images || $[11] !== staticHeight) {
        t8 = (status)=>{
            if (null == status ? void 0 : status.rejected) return /*#__PURE__*/ jsx(MediaEmpty, {
                height: staticHeight,
                radius: "m"
            });
            if (null == status ? void 0 : status.fulfilled) return /*#__PURE__*/ jsx("img", {
                src: images[currentIndex].src,
                alt: `Slide ${currentIndex}`,
                style: {
                    maxWidth: "100%",
                    height: staticHeight,
                    objectFit: "contain"
                },
                loading: "lazy"
            });
            return /*#__PURE__*/ jsx(Skeleton, {
                height: staticHeight,
                width: "100%",
                variant: "rect"
            });
        };
        $[9] = currentIndex;
        $[10] = images;
        $[11] = staticHeight;
        $[12] = t8;
    } else t8 = $[12];
    const getCurrentImage = t8;
    if (!Object.keys(loadedImages).length) {
        let t9;
        if ($[13] !== staticHeight) {
            t9 = /*#__PURE__*/ jsx(Skeleton, {
                height: staticHeight,
                width: "100%",
                variant: "rect"
            });
            $[13] = staticHeight;
            $[14] = t9;
        } else t9 = $[14];
        return t9;
    }
    if (hasError) {
        let t9;
        if ($[15] !== staticHeight) {
            t9 = /*#__PURE__*/ jsx(MediaEmpty, {
                height: staticHeight,
                variant: "multiple",
                radius: "m"
            });
            $[15] = staticHeight;
            $[16] = t9;
        } else t9 = $[16];
        return t9;
    }
    const t9 = loadedImages[images[currentIndex].src] ? "bg.dark.primary" : "bg.light.primary";
    const t10 = loadedImages[images[currentIndex].src];
    let t11;
    if ($[17] !== getCurrentImage || $[18] !== t10) {
        t11 = getCurrentImage(t10);
        $[17] = getCurrentImage;
        $[18] = t10;
        $[19] = t11;
    } else t11 = $[19];
    const t12 = 0 === currentIndex ? "default" : "pointer";
    let t13;
    if ($[20] !== currentIndex || $[21] !== goToNext) {
        t13 = ()=>goToNext(currentIndex - 1);
        $[20] = currentIndex;
        $[21] = goToNext;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ jsx(Icon, {
            name: "chevron_left_small_outline",
            size: "24",
            color: "text.dark.primary"
        });
        $[23] = t14;
    } else t14 = $[23];
    let t15;
    if ($[24] !== t12 || $[25] !== t13) {
        t15 = /*#__PURE__*/ jsx(Box, {
            position: "absolute",
            top: "calc(50% - 16px)",
            left: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
            radius: "round",
            bgcolor: "bg.dark.secondary",
            color: "text.dark.primary",
            cursor: t12,
            onClick: t13,
            children: t14
        });
        $[24] = t12;
        $[25] = t13;
        $[26] = t15;
    } else t15 = $[26];
    const t16 = currentIndex === images.length - 1 ? "default" : "pointer";
    let t17;
    if ($[27] !== currentIndex || $[28] !== goToNext) {
        t17 = ()=>goToNext(currentIndex + 1);
        $[27] = currentIndex;
        $[28] = goToNext;
        $[29] = t17;
    } else t17 = $[29];
    let t18;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ jsx(Icon, {
            name: "chevron_right_small_outline",
            size: "24",
            color: "text.dark.primary"
        });
        $[30] = t18;
    } else t18 = $[30];
    let t19;
    if ($[31] !== t16 || $[32] !== t17) {
        t19 = /*#__PURE__*/ jsx(Box, {
            position: "absolute",
            top: "calc(50% - 16px)",
            right: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
            radius: "round",
            bgcolor: "bg.dark.secondary",
            color: "text.dark.primary",
            cursor: t16,
            onClick: t17,
            children: t18
        });
        $[31] = t16;
        $[32] = t17;
        $[33] = t19;
    } else t19 = $[33];
    const t20 = currentIndex + 1;
    let t21;
    if ($[34] !== t20) {
        t21 = /*#__PURE__*/ jsx(Typography, {
            variant: "overline",
            color: "text.dark.primary",
            children: t20
        });
        $[34] = t20;
        $[35] = t21;
    } else t21 = $[35];
    let t22;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ jsx(Typography, {
            variant: "overline",
            color: "text.dark.primary",
            children: "/"
        });
        $[36] = t22;
    } else t22 = $[36];
    let t23;
    if ($[37] !== images.length) {
        t23 = /*#__PURE__*/ jsx(Typography, {
            variant: "overline",
            color: "text.dark.primary",
            children: images.length
        });
        $[37] = images.length;
        $[38] = t23;
    } else t23 = $[38];
    let t24;
    if ($[39] !== t21 || $[40] !== t23) {
        t24 = /*#__PURE__*/ jsxs(Box, {
            position: "absolute",
            bottom: 16,
            left: "50%",
            display: "flex",
            alignItems: "center",
            gap: "2",
            px: "8",
            py: "2",
            transform: "translateX(-50%)",
            radius: "l",
            bgcolor: "bg.dark.secondary",
            children: [
                t21,
                t22,
                t23
            ]
        });
        $[39] = t21;
        $[40] = t23;
        $[41] = t24;
    } else t24 = $[41];
    let t25;
    if ($[42] !== t11 || $[43] !== t15 || $[44] !== t19 || $[45] !== t24 || $[46] !== t9) {
        t25 = /*#__PURE__*/ jsxs(Box, {
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: t9,
            radius: "m",
            overflow: "hidden",
            children: [
                t11,
                t15,
                t19,
                t24
            ]
        });
        $[42] = t11;
        $[43] = t15;
        $[44] = t19;
        $[45] = t24;
        $[46] = t9;
        $[47] = t25;
    } else t25 = $[47];
    return t25;
};
export { ImagesGallerySlider };
